import React from 'react';
import clsx from 'clsx';

export interface IngredientType {
  summary?: string;
  amount?: string;
  productLink?: string | null;
}
export const IngredientPrint = ({ ingredient }: { ingredient: IngredientType }) => {
  return (
    <div key={ingredient.summary} className="flex print:break-inside-avoid print:relative">
      {!!ingredient.amount && (
        <b className="pr-2 text-right text-sm font-bold print:break-inside-avoid whitespace-nowrap">
          {ingredient.amount}
        </b>
      )}
      <span className={clsx('print:relative text-sm', ingredient.productLink && 'underline')}>
        {ingredient.summary}
      </span>
    </div>
  );
};
